import { useState } from "react";
import { Button } from "react-bootstrap";
import { ShieldQuestion, PhoneCall, FileText, BriefcaseMedical, Phone, CalendarIcon, User, Link } from 'lucide-react'
import PatientInfoModal from "./PatientInfoModal";
import formatDateSolicitation from "../../../utils/formatDateSolicitation";
import AuthorizationIcon from "../../../components/AuthorizationIcon";
import api from "../../../api";
import Swal from "sweetalert2";

export default function PatientPartialCard({ patient }) {
  const [modalOpen, setModalOpen] = useState(false);

  const hasLgpdStatus = patient.patient.sms_status_lgpd !== undefined;
  const isAuthorized = patient.patient.sms_status_lgpd;

  function isValidPhone(str) {
    const regex = /^\(?\d{2}\)?\s?9?\s?\d{4}-?\d{4}$/;
    return regex.test(str);
  }

  const openWhatsApp = (whatsapp, e) => {
    e.preventDefault()
    e.stopPropagation()

    const cleanNumber = whatsapp.replace(/\D/g, "")
    window.open(`https://wa.me/55${cleanNumber}`, "_blank")
  }

  const sendWhatsappLink = async (patient, e) => {
    e.preventDefault();

    const confirmResult = await Swal.fire({
      title: 'Atenção',
      text: 'Deseja enviar o link de autorização para o Whatsapp do paciente?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, enviar',
      cancelButtonText: 'Cancelar'
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    Swal.fire({
      title: 'Aguarde',
      text: 'Gerando o link de autorização...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const response = await api.post('api/consent/send-whatsapp-budget', {
        budget_id: patient.id,
        professional_cpf: patient.patient.professional_cpf,
        professional_name: patient.patient.professional_name,
        scope: "uso-dados-pessoais",
      });

      Swal.close();

      const message = response.data.data;
      const encodedMessage = encodeURIComponent(message)

      const cleanNumber = patient.name.replace(/\D/g, "")
      window.open(`https://wa.me/55${cleanNumber}?text=${encodedMessage}`, "_blank")

    } catch (error) {
      console.error("Erro ao gerar link do WhatsApp:", error);

      Swal.close();
      Swal.fire({
        title: 'Erro!',
        text: 'Ocorreu um erro ao gerar o link.',
        icon: 'error',
        confirmButtonText: 'Fechar'
      });
    }
  };

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className="patient-card">
        <div className="patient-avatar">
          <ShieldQuestion size={28} />
        </div>

        <div className="patient-info" style={{ maxWidth: '55%' }}>
          <div className="patient-main-info align-items-center">
            <div className="d-flex align-items-center gap-4">

              <div className="d-flex flex-column gap-3">
                <span className="fs-6">
                  {isValidPhone(patient.name) ?
                    <PhoneCall size={20} className="text-muted me-2" />
                    : <User size={20} className="text-muted me-2" />
                  }
                  {patient.name} {patient.patient.sms_name && `- ${patient.patient.sms_name}`}
                </span>
                <span className="fs-6"><BriefcaseMedical size={20} className="text-muted me-2" /> {patient.patient.professional_name}</span>
                <p className="fw-semibold fs-6">
                  <CalendarIcon className="text-muted me-2" size={20} />{formatDateSolicitation(patient.patient.date_solicitation)[0]} - {formatDateSolicitation(patient.patient.date_solicitation)[1]}
                </p>
              </div>
            </div>

            {
              isValidPhone(patient.name) && (
                <div
                  className="btn-whatsapp d-flex align-items-center justify-content-center rounded-circle text-white me-5"
                  title="Contatar paciente por Whatsapp"
                  onClick={(e) => openWhatsApp(patient.name, e)}
                >
                  <Phone size={24} style={{ alignSelf: 'center' }} />
                </div>
              )
            }
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center gap-5">
          <Button
            variant="outline-success"
            size="sm"
            className="d-flex align-items-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
              sendWhatsappLink(patient, e);
            }}
          >
            <Link size={28} />
            <span>Link Whatsapp</span>
          </Button>

          <Button
            variant="outline-primary"
            size="sm"
            className="d-flex align-items-center gap-2"
            onClick={(e) => {
              e.stopPropagation();
              openModal();
            }}
            disabled={hasLgpdStatus && !isAuthorized}
          >
            <FileText size={28} />
            <span>Preencher informações</span>
          </Button>

          {hasLgpdStatus && (
            <AuthorizationIcon
              id={patient.id}
              professionalCpf={patient.patient.professional_cpf}
              professionalName={patient.patient.professional_name}
              authorized={isAuthorized}
              count={patient.patient.sms_quantity_send}
            />
          )}
        </div>
      </div>

      <PatientInfoModal
        patient={patient}
        isOpen={modalOpen}
        onClose={closeModal}
      />
    </>
  );
}